module.exports = {"ru":{"modules":{"home":{"title":"Главный экран","tabbarTitle":"Главная","call":{"title":"Позвонить"}}}}}